// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ONLXX","toggle":"styles_toggle__1y5NQ","preview":"styles_preview__2NS6z"};